import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import { CData } from "src/Data";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components/";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import { _Accordion, _AddClientButton, _ButtonAPI, _CompaniesGroupDetails } from "..";
import { _Autocomplete, _Select } from "../../form";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

const OptionsATI: Dati.TDictTipo = {};
OptionsATI["ATI"] = new Dati.CTipo("ATI", "ATI");
OptionsATI["RTI"] = new Dati.CTipo("RTI", "RTI");
OptionsATI["CostituendaATI"] = new Dati.CTipo("CostituendaATI", "CostituendaATI");
OptionsATI["CostituendoRTI"] = new Dati.CTipo("CostituendoRTI", "CostituendoRTI");

class CDatiPolizzaFide {
    public ID_FideAffidamento: number = 0;
    public ID_AnagBeneficiario: number = 0;
    public ATI: boolean = false;
    public EtichettaATI: string = "ATI";
    public MandantiJSON: Glob.DatiJSON = "[]";
    public Durata: number = 0;
    public LuogoEsecuzione: string = "";
    public DataSvincolo: Date = new Date(Date.now());
}

export const _PolicyBondAccordion = (): JSX.Element => {
    const history = useHistory();
    const { ShowDialog } = useContext(AlertDialogContext);

    const [formData, setFormData] = useReducerOnChange<Dati.CDatiPolizza>({
        ...new Dati.CDatiPolizza(),
        ID_TipoRamo: Glob.TipiRami_Fideiussioni,
        ID_AnagPOS: Glob.GetSessione().ID_Anag,
        CoAssicurazioneJSON: "[]"
    });

    const [policyData, setPolicyData] = useReducerOnChange<CDatiPolizzaFide>(new CDatiPolizzaFide());

    useEffect(() => {
        setFormData({ Type: "OnChangeFromValue", Name: "CoAssicurazioneJSON", Value: "[]" });
        getProductBinder();
    }, [formData.ID_TipoProdotto]);

    useEffect(() => {
        setPolicyData({ Type: "OnChangeFromValue", Name: "ID_FideAffidamento", Value: 0 });
        setPolicyData({ Type: "OnChangeFromValue", Name: "ID_TipoProdotto", Value: 0 });
    }, [formData.ID_AnagContraente]);

    const getProductBinder = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetFideBinderProdotto?id_FideAffidamento=${policyData.ID_FideAffidamento}&id_TipoProdotto=${formData.ID_TipoProdotto}&dataEffetto=${moment().utc().format()}`,
            OnRis: onGetProductBinder,
            OnErrore: (sender: ChiamaWeb, error: Error) => onApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const onGetProductBinder = (sender: ChiamaWeb, data: Dati.CRisAPISemplice<string>) => {
        setFormData({ Type: "OnChangeFromValue", Name: "Dato.CoAssicurazioneJSON", Value: getSingleInsurance(data.Dato) });
    };

    const getSingleInsurance = (productBinderJSON: string): string => {
        if (productBinderJSON) {
            const productBinder: Dati.CDatoBinderProdottoCoAssicurazione[] = JSON.parse(productBinderJSON);

            if (productBinder.length == 1) {
                const coInsurance = new Dati.CDatoCoAssicurazione();
                coInsurance.Delegataria = true;
                coInsurance.Quota = 100;
                coInsurance.ID_Anag = productBinder[0].ID_AnagCompagnia;
                coInsurance.ID_Binder = productBinder[0].ID_Binder;
                coInsurance.ID_BinderCompagnia = productBinder[0].ID_BinderCompagnia;

                return JSON.stringify([coInsurance]);
            } else {
                return productBinderJSON;
            }
        }

        return "[]";
    };

    const getFormData = (): Dati.CIngrAPI<Dati.CDatiPolizza> => {
        const data = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        const duration =
            formData.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaLavori ||
            formData.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaForniture ||
            formData.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaServizi
                ? 180
                : 0;
        const releaseDate = new CData(moment(formData.DataEffetto).toDate(), true).AddGiorni(duration).Data;

        data.Dato = formData;
        data.Dato.DatiPolizza = JSON.stringify({
            ...policyData,
            LuogoEsecuzione: "Vedasi oggetto garanzia",
            Durata: duration,
            DataSvincolo: releaseDate,
            DataFine: releaseDate
        });

        return data;
    };

    const onClickSave = (data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            history.push(`/anagrafica/${formData.ID_AnagContraente}/fideaffidamento/${policyData.ID_FideAffidamento}/fidepolizza/${data.ID_Chiave}`);
        }
    };

    const onApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const onAddClient = (val: string) => {
        setFormData({ Type: "OnChangeFromValue", Name: "ID_AnagBeneficiario", Value: val });
    };

    const checkValidity = (): boolean => {
        if (policyData.ATI) {
            let QuotaMandataria: number = 100;
            let QuotaMandanteMax: number = 0;
            let Mandanti: Dati.CDatoMandante[] = JSON.parse(policyData.MandantiJSON);

            if (Mandanti.length == 0) return false;
            for (let M: number = 0; M < Mandanti.length; M++) {
                QuotaMandataria -= Mandanti[M].Quota;
                if (QuotaMandanteMax < Mandanti[M].Quota) {
                    QuotaMandanteMax = Mandanti[M].Quota;
                }
                if (Mandanti[M].RagioneSociale.trim().length == 0 || Mandanti[M].PartitaIVA.trim().length != 11) {
                    return false;
                }
            }
            if (QuotaMandataria < QuotaMandanteMax) {
                return false;
            }
        }

        return (
            formData.ID_AnagContraente > 0 &&
            formData.ID_AnagPOS > 0 &&
            formData.ID_TipoRamo > 0 &&
            formData.ID_TipoProdotto > 0 &&
            //formData.CoAssicurazioneJSON != "[]" &&
            policyData.ID_AnagBeneficiario > 0 &&
            policyData.ID_FideAffidamento > 0
        );
    };

    const isFormValid = checkValidity();
    const isATIVisible = formData.ID_TipoProdotto == 4 || formData.ID_TipoProdotto == 17 || formData.ID_TipoProdotto == 18;

    return (
        <_Accordion Title="Polizza" Id="policy" defaultExpanded>
            <Grid container>
                <Grid item xs={12}>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={formData.ID_AnagPOS}
                                    Name="ID_AnagPOS"
                                    Label="POS"
                                    Disabled={!Glob.AzioneAbilitata("FideAffidamentoID_AnagDa", 2)}
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={formData.ID_AnagContraente}
                                    Name="ID_AnagContraente"
                                    Label="Contraente"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    SearchInput
                                    Value={policyData.ID_FideAffidamento}
                                    Name="ID_FideAffidamento"
                                    Label="Affidamento"
                                    OnChange={(e, val) => setPolicyData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url={`/api/FideAffidamento/ListaAffidamentiAnagrafica?sottoscritti=true&ID_AnagA=${formData.ID_AnagContraente}`}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    SearchInput
                                    Value={formData.ID_TipoProdotto}
                                    Name="ID_TipoProdotto"
                                    Label="Prodotto"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url={`/api/Tipi/Tipo?tabella=TipiProdottiFide&campo=TipoProdotto&parametri=${policyData.ID_FideAffidamento}`}
                                />
                            </Grid>
                            {isATIVisible && (
                                <Grid item xs={12} md={3}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={policyData.ATI}
                                                onChange={e => setPolicyData({ Type: "OnChangeFromValue", Name: e.currentTarget.name, Value: e.currentTarget.checked })}
                                                name="ATI"
                                            />
                                        }
                                        label={Trad.Trad("ATI")}
                                    />
                                </Grid>
                            )}
                            {policyData.ATI && (
                                <Grid container spacing={4} item xs={12}>
                                    <Grid item xs={12} md={4}>
                                        <_Select
                                            Value={policyData.EtichettaATI}
                                            Name="EtichettaATI"
                                            Label="EtichettaATI"
                                            OnChange={(e, val) => setPolicyData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                            Options={OptionsATI}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <_CompaniesGroupDetails
                                            Data={policyData.MandantiJSON}
                                            ParentCompanyColumn={false}
                                            OnChange={val => setPolicyData({ Type: "OnChangeFromValue", Name: "MandantiJSON", Value: val })}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                            <Grid item xs={12} md={6}>
                                <_AddClientButton OnAddClient={onAddClient}>
                                    <_Autocomplete
                                        Value={policyData.ID_AnagBeneficiario}
                                        Name="ID_AnagBeneficiario"
                                        Label="Beneficiario"
                                        OnChange={(e, val) => setPolicyData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                        Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    />
                                </_AddClientButton>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4} justify="flex-end">
                            <Grid item>
                                <_ButtonAPI Testo={Trad.Trad("Nuovo")} URL="/api/polizza/salvapolizza" OnInvio={getFormData} OnClick={onClickSave} OnErrore={onApiError} Attivo={isFormValid} />
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </_Accordion>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/NewPolicy/PolicyBondAccordion.tsx